var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShopDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73071 4L0 10.5608V25H6.78571V14.0196H12.2143V25H19V10.2451L9.73071 4Z",
    fill: "#0088C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0V2.09722L14.7692 3.94444L17.1646 5.55556H18.9231V6.73611L21.6923 8.59722V11.1111H24.4615V13.8889H21.6923V16.6667H24.4615V19.4444H21.6923V25H30V0H12ZM24.4615 8.33333H21.6923V5.55556H24.4615V8.33333Z",
    fill: "#0088C2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopDetails);
export default __webpack_public_path__ + "static/media/ShopDetails.b8e9723e606a128bb9be68da2f044745.svg";
export { ForwardRef as ReactComponent };